import React, { useEffect, useState } from "react";
import TmsTable from "../../../../../components/tms-customs/tms-table";
import { withRouter } from "../../../../../utils/tms-with-router/tms-with-router";
import catchErrorFunction from "../../../../../utils/tms-catch-error/tms-catch-error";
import { Button, Col, Drawer, Switch } from "antd";
import "../../../../../assets/css/tms-darshanam/tms-d-inner-pages-all.scss";
import TmsKalyanakattainnerActions from "../../../../../components/tms-service-management/tms-sm-kalayanakatta/tms-sm-kalayanakatta-inner-actions";
import TextArea from "antd/lib/input/TextArea";
import TmsKalayanakattaService from "../../../../../services/tms-kalayanakatta.service";
import TmsKalyanakattaInnerPagesAnd from "./tms-kalyanakatta-inner-pages-and";

const TmsKalyankattaInnerPagesAll = ({ router }) => {
  const [updateFlag, setUpdateFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [kalayanakattaData, setKalyanakattaData] = useState([]);
  const [tmsModalVisible, settmsModalVisible] = useState(false);
  const [viewKalyanakattaData, setViewKalyanakattaData] = useState();
  const [editFlag, setEditFlag] = useState();
  const [productId, setProductId] = useState();
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(15);
  const [tableTotalSize, setTabelTotalSize] = useState(0);
  const [showDrawer, setShowDrawer] = useState(false);
  const [termsData, setTermsData] = useState([]);
  const [miniTicket, setMiniTicket] = useState(false);
  const [onlinetermsData, setOnlineTermsData] = useState([]);

  const tableColums = [
    ["Name", viewKalyanakattaData?.name],
    ["Description", viewKalyanakattaData?.description],
    ["Price", viewKalyanakattaData?.price],
    [
      "POS-(Status)",
      viewKalyanakattaData?.counterEnabled ? "enabled" : "disabled",
    ],
    [
      "Online-(Status)",
      viewKalyanakattaData?.onlineEnabled ? "enabled" : "disabled",
    ],
  ];

  const switchTrigger = async (key) => {
    setLoading(true);
    try {
      const darData = await TmsKalayanakattaService.viewKalyanakatta(key);
      setViewKalyanakattaData(darData);
      settmsModalVisible(true);
      setEditFlag(true);
      setProductId(key);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
    }
    // try {
    //   const KalayanaData = await TmsKalayanakattaService.viewKalyanakatta(key);
    //   let body = {
    //     name: KalayanaData?.name,
    //     description: KalayanaData?.description,
    //     counterEnabled:
    //       from === "counter" ? status : KalayanaData?.counterEnabled,
    //     onlineEnabled: from === "online" ? status : KalayanaData?.onlineEnabled,
    //     price: KalayanaData?.price,
    //     // imageUrl: KalayanaData?.imageUrl,
    //   };
    //   await TmsKalayanakattaService.editKalyanakatta(key, body);
    //   setUpdateFlag(Math.random() + 1);
    //   // console.log(updateFlag);
    // } catch (error) {
    //   catchErrorFunction(
    //     error,
    //     "Token Expired, redirecting to login page in 5 seconds",
    //     router
    //   );
    // }
    setLoading(false);
  };

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
  };

  useEffect(() => {
    router.location?.pathname === "/service-management/kalyanakatta" &&
      getKalyanakattaList();
    if (!editFlag) {
      settmsModalVisible(false);
    }
  }, [
    updateFlag,
    editFlag,
    tableCurrentPage,
    tablePageSize,
    router.location?.pathname,
  ]);

  const getKalyanakattaList = async () => {
    setLoading(true);
    try {
      let data = [];
      setKalyanakattaData([]);

      data = await TmsKalayanakattaService.getKalayanakatta(
        tableCurrentPage,
        tablePageSize
      );

      setTabelTotalSize(data?.meta?.totalItems);
      setKalyanakattaData(
        data?.items?.map((item) => {
          return {
            key: item.id,
            ...item,
          };
        })
      );
      setLoading(false);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Kalyanakatta Name",
      dataIndex: "name",
      key: "name",
      //   ...getColumnSearchProps("darshanam_name"),
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      sorter: (a, b) => a.price > b.price,
      render: (text) => {
        return `Rs. ${text}`;
      },
    },

    {
      title: "POS-(Status)",
      dataIndex: "counterEnabled",
      key: "counterEnabled",
      render: (text, record) => {
        return (
          <Switch
            size={"small"}
            checked={text}
            style={{ background: text ? "#4CBB17" : "EFEFEF" }}
            onClick={() => {
              switchTrigger(record?.key, !text, "counter");
            }}
          />
        );
      },
    },
    {
      title: "Online-(Status)",

      dataIndex: "onlineEnabled",
      key: "onlineEnabled",
      render: (text, record) => {
        return (
          <Switch
            size={"small"}
            checked={text}
            style={{
              background: text ? "#4CBB17 " : "EFEFEF ",
            }}
            onClick={() => {
              switchTrigger(record?.key, !text, "online");
            }}
          />
        );
      },
    },
    {
      title: "Action",
      render: (record) => {
        return (
          <TmsKalyanakattainnerActions
            record={record}
            setLoading={setLoading}
            setViewKalyanakattaData={setViewKalyanakattaData}
            settmsModalVisible={settmsModalVisible}
            setUpdateFlag={setUpdateFlag}
            setEditFlag={setEditFlag}
            setProductId={setProductId}
            setShowDrawer={setShowDrawer}
            setTermsData={setTermsData}
            setOnlineTermsData={setOnlineTermsData}
            setMiniTicket={setMiniTicket}
          />
        );
      },
    },
  ];

  return (
    <>
      <TmsTable
        columns={columns}
        loading={loading}
        dataSource={kalayanakattaData}
        handleTableChange={handleTableChange}
        pagination={{
          total: tableTotalSize,
          current: tableCurrentPage,
          pageSize: tablePageSize,
        }}
      />
      <Drawer
        className="DetailsModal"
        width={editFlag ? "800px" : "600px"}
        visible={tmsModalVisible}
        onClose={() => {
          settmsModalVisible(false);
          setEditFlag(false);
          setViewKalyanakattaData(null);
        }}
        title={editFlag ? "Edit Kalyanakatta" : "Kalyanakatta Details"}
      >
        {editFlag ? (
          <TmsKalyanakattaInnerPagesAnd
            viewKalyanakattaData={viewKalyanakattaData}
            editFlag={editFlag}
            productId={productId}
            setEditFlag={setEditFlag}
            settmsModalVisible={settmsModalVisible}
          />
        ) : (
          <div className="viewDetails">
            <Col style={{ width: "100%" }}>
              <table className="DetailsTable">
                {tableColums.map((item) => {
                  return (
                    <tr key={"table" + item[0]}>
                      <th>{item[0]}</th>
                      <td>{item[1]}</td>
                    </tr>
                  );
                })}
              </table>
            </Col>
            <br />
            {/* <Col className="ImgCol">
              <img src={viewKalyanakattaData?.imageUrl} alt="Image" />
            </Col> */}
          </div>
        )}
      </Drawer>
      <Drawer
        className="TermsDrawer"
        visible={showDrawer}
        onClose={() => {
          setShowDrawer(false);
          setTermsData([]);
          setOnlineTermsData([]);
        }}
        title="Terms & Conditions"
        extra={
          <Button
            type="primary"
            onClick={async () => {
              setLoading(true);
              try {
                await TmsKalayanakattaService.updateTerms(
                  productId,
                  termsData?.toString()?.replaceAll(",", "\n")?.split("\n"),
                  onlinetermsData
                    ?.toString()
                    ?.replaceAll(",", "\n")
                    ?.split("\n"),
                  miniTicket
                );
                setUpdateFlag(Math.random() + 1);
                setShowDrawer(false);
                setTermsData([]);
                setOnlineTermsData([]);
                setMiniTicket(false);
              } catch (error) {
                catchErrorFunction(
                  error,
                  "Token Expired, redirecting to login page in 5 seconds",
                  router
                );
              }
              setLoading(false);
            }}
          >
            Submit
          </Button>
        }
      >
        POS
        <TextArea
          maxLength={2200}
          rows={5}
          value={termsData?.toString()?.replaceAll(",", "\n")}
          onChange={(e) => {
            setTermsData(e.target.value);
          }}
        />
        <br />
        <br />
        Online
        <TextArea
          maxLength={2200}
          rows={5}
          value={onlinetermsData?.toString()?.replaceAll(",", "\n")}
          onChange={(e) => {
            setOnlineTermsData(e.target.value);
          }}
        />
        {/* <Row className="formRow" style={{ width: "100%", paddingTop: "10px" }}>
          <Checkbox
            style={{ paddingRight: "10px" }}
            checked={miniTicket}
            onChange={(e) => setMiniTicket(e.target.checked)}
          />
          <label>Mini ticket</label>
        </Row> */}
      </Drawer>
    </>
  );
};

export default withRouter(TmsKalyankattaInnerPagesAll);
